import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const superNav: CustomTheme.CSSProperties = {
  margin: 0,
  backgroundColor: 'blue.5',
  '& > span': {
    color: 'blue.70',
  },
};

const chart: CustomTheme.VariantCSSKeys<TextContentVariantsType> = {
  siteNav: {
    margin: 0,
    backgroundColor: 'orange.5',
    '& > span': {
      color: 'orange.70',
    },
  },
  superNav,
};

const co: CustomTheme.VariantCSSKeys<TextContentVariantsType> = {
  siteNav: {
    margin: 0,
    backgroundColor: 'blue.5',
    '& > span': {
      color: 'blue.70',
    },
  },
  superNav,
};

const edu: CustomTheme.VariantCSSKeys<TextContentVariantsType> = {
  siteNav: {
    margin: 0,
    backgroundColor: 'indigo.5',
    '& > span': {
      color: 'indigo.70',
    },
  },
  superNav,
};

const scale: CustomTheme.VariantCSSKeys<TextContentVariantsType> = {
  siteNav: {
    margin: 0,
    backgroundColor: 'indigo.5',
    '& > span': {
      color: 'indigo.70',
    },
  },
  superNav,
};

const spark: CustomTheme.VariantCSSKeys<TextContentVariantsType> = {
  siteNav: {
    margin: 0,
    backgroundColor: 'red.5',
    '& > span': {
      color: 'red.70',
    },
  },
  superNav,
};

const textContent: Product.VariantKeyModes<TextContentVariantsType> = {
  products: {
    chart: chart,
    chartblog: chart,
    co: co,
    edu: edu,
    scale: scale,
    spark: spark,
  },
};

export type TextContentVariantsType = 'siteNav' | 'superNav';
export const textContentVariants = Object.keys(chart) as TextContentVariantsType[];

export default textContent;
